import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { usePermissions } from '@hooks/usePermissions';
import { useEffect } from 'react';
import { useTemplateResponseActions } from './useTemplateResponseActions';

export const useTemplateResponseInit = (
  withoutLoadingAnimation = false,
  shouldFetch = true,
) => {
  const { fetchTemplateResponses } = useTemplateResponseActions();
  const { hasPermissions } = usePermissions();

  useEffect(() => {
    if (
      shouldFetch &&
      hasPermissions([PERMISSIONS.TEMPLATE_RESPONSE.TEMPLATE_RESPONSE_LIST])
    ) {
      fetchTemplateResponses(withoutLoadingAnimation);
    }
  }, [
    fetchTemplateResponses,
    withoutLoadingAnimation,
    hasPermissions,
    shouldFetch,
  ]);
};
